import { Button, Dialog, DialogActions, DialogContent, TextField } from '@mui/material';
import { useState } from 'react';
import { DialogTitleWithCloseIcon } from 'src/components/organisms/DialogTitleWithCloseIcon/DialogTitleWithCloseIcon';

interface SaveSettingsDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (filterName: string) => Promise<boolean | undefined>;
    isSaving: boolean;
}

const SaveSettingsDialog = ({ open, onClose, onSave, isSaving }: SaveSettingsDialogProps) => {
    const [settingName, setSettingName] = useState('');

    const handleSave = async () => {
        if (!settingName || isSaving) return;
        if (await onSave(settingName)) setSettingName('');
    };

    const handleTextFieldKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            handleSave();
        } else if (event.key === 'Escape') {
            onClose();
        }
    };

    /**
     * disableRestoreFocus is set to solve an issue, that according to sources is only a problem in strict mode, during development build - since componets are rendered twice in this mode.
     * This will prevent the modal from restoring focus to previously focused element once modal is hidden or unmounted.
     * It shouldn't be a problem in this case to always have this set to true, since there are no important focusable elements behind the modal that the user would need to access right after closing the modal.
     */
    return (
        <Dialog disableRestoreFocus maxWidth={'xs'} fullWidth open={open} onClose={onClose}>
            <DialogTitleWithCloseIcon title="Create filter and column settings" handleClose={onClose} />
            <DialogContent>
                <TextField
                    autoFocus
                    label="Setting Name"
                    fullWidth
                    value={settingName}
                    onChange={(e) => setSettingName(e.target.value)}
                    onKeyDown={handleTextFieldKeyDown}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="text">
                    Cancel
                </Button>
                <Button onClick={handleSave} variant="contained" color="info" disabled={!settingName || isSaving}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveSettingsDialog;
